var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress as MCircularProgress, circularProgressClasses, Typography, useTheme, } from '@mui/material';
export default function CircularProgress(_a) {
    var _b;
    var value = _a.value, _c = _a.hidePercentage, hidePercentage = _c === void 0 ? false : _c, props = __rest(_a, ["value", "hidePercentage"]);
    var theme = useTheme();
    var progressValue = value || 0;
    var progressSize = 57;
    return (_jsxs(Box, __assign({ sx: { position: 'relative', display: 'inline-flex' } }, { children: [_jsx(MCircularProgress, __assign({ "aria-hidden": "true", variant: "determinate", sx: {
                    color: theme.palette.neutral[theme.palette.mode === 'light' ? 80 : 30],
                }, size: progressSize, thickness: 4 }, props, { value: 100 })), _jsx(MCircularProgress, __assign({ "aria-hidden": "true", variant: "determinate", disableShrink: true, sx: (_b = {
                        position: 'absolute',
                        left: 0
                    },
                    _b["& .".concat(circularProgressClasses.circle)] = {
                        strokeLinecap: 'butt',
                    },
                    _b), value: value, size: progressSize, thickness: 4 }, props)), _jsx(Box, __assign({ sx: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }, { children: _jsx(Typography, __assign({ "aria-label": "Percentage: ".concat(Math.round(progressValue)), variant: "caption", component: "div", color: "text.primary", fontWeight: 700, lineHeight: "24px", fontSize: "16px" }, { children: !hidePercentage && "".concat(Math.round(progressValue), "%") })) }))] })));
}
